import { z } from "zod";

import type { components } from "@/api/schema";
import { moneyStringSchema, parseMoneyAmount } from "@/shared/lib/money";

// A synthetic-cart amount is never negative (unlike settlement `fees`, which is
// genuinely signed — that asymmetry is exactly why moneyStringSchema itself
// doesn't bake in non-negativity). Shared by unit_price/discount/shipping below.
const money = moneyStringSchema("promotion:simulate.err_money_format").refine(
  (v) => parseMoneyAmount(v) >= 0,
  "promotion:simulate.err_money_negative",
);

/** One synthetic cart line — mirrors components["schemas"]["SimulateCartLine"]. */
export const simulateCartLineSchema = z.object({
  sku: z.string().trim().min(1, "promotion:simulate.err_sku_required"),
  quantity: z.number().int().min(1),
  unit_price: money,
  discount: money.default("0.00"),
});

/** Synthetic cart for POST /v1/promotions/{id}/simulate — components["schemas"]["SimulateCart"]. */
export const simulateCartSchema = z.object({
  lines: z.array(simulateCartLineSchema).min(1, "promotion:simulate.err_no_lines"),
  discount: money.default("0.00"),
  shipping: money.default("0.00"),
  is_cod: z.boolean().default(false),
});

export type SimulateCartValues = z.infer<typeof simulateCartSchema>;
/** Form *input* type — `.default()` fields (discount/shipping/is_cod) are optional on input. */
export type SimulateCartInput = z.input<typeof simulateCartSchema>;
export type SimulateCartLineValues = z.infer<typeof simulateCartLineSchema>;

// Compile-time guard: form output must satisfy the BE cart body.
type _AssertCart = SimulateCartValues extends components["schemas"]["SimulateCart"] ? true : never;
const _cart: _AssertCart = true;
void _cart;
